<div class="foc-container d-flex" (dblclick)="preventZoom($event)">

    <!-- prefetching svg -->
    <div class="preload-svgs" style="display: none;">
        <img src="{{imageBasePath}}assets/img/Toolbar/Home.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/TOC.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Tools.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Double Page.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Single Page.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Invert.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Scribble.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Highlighter.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Eraser.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Zoom in.svg" alt="Zoom in">
        <img src="{{imageBasePath}}assets/img/Toolbar/Zoom out.svg" alt="Zoom out">
        <img src="{{imageBasePath}}assets/img/Toolbar/Fit to width.svg" alt="Fit to Width">
        <img src="{{imageBasePath}}assets/img/Toolbar/Fit to height.svg" alt="Fit to Height">

        <!-- hotspot icons -->
        <img src="{{imageBasePath}}assets/img/Hotspots/AK_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/audio_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/game_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/jump_page_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/link_icon.svg" class="shrink-button" alt="PDF">
        <img src="{{imageBasePath}}assets/img/Hotspots/LO_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/video_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/zoom_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/note_icon.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Hotspots/note_selected_icon.svg" class="shrink-button" alt="Shrink">

        <!-- Persistemce icons -->
        <img src="{{imageBasePath}}assets/img/Toolbar/Error_Triangle.svg" class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Persistence/error.svg" class="shrink-button" alt="Error">
        <img src="{{imageBasePath}}assets/img/Persistence/saved.svg" class="shrink-button" alt="Saved">
        <img src="{{imageBasePath}}assets/img/Persistence/saving.svg" class="shrink-button" alt="Saving">
        <img src="{{imageBasePath}}assets/img/Persistence/warning.svg" class="shrink-button" alt="Warnig">
        <img src="{{imageBasePath}}assets/img/Toolbar/Spotlight.svg"  class="shrink-button" alt="Shrink">
        <img src="{{imageBasePath}}assets/img/Toolbar/Timer.svg" class="shrink-button" alt="Shrink">

        <!-- Images to be prefetched but after the page has completed initial loading -->
        <div *ngIf="renderSVGs">
            <img src="{{imageBasePath}}assets/img/Notes/AddCircle.svg" alt="add_circle">
            <!-- <img src="{{imageBasePath}}assets/img/Vertical_Drag.svg" alt="Vertical Dragger"> -->
            <img src="{{imageBasePath}}assets/img/Shrink.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/captions_new.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/captions_new_white.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/captions_new_fill_purple.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/captions_fill.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/transcripts_new.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/transcripts_fill.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/transcripts_new_white.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/transcripts_new_fill_purple.svg" class="shrink-button" alt="Shrink">
            <!-- <img src="{{imageBasePath}}assets/img/Horizontal_Drag.svg" class="shrink-button" alt="Shrink"> -->
            <img src="{{imageBasePath}}assets/img/Horizontal_Drag_White.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Shrink_black.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Download.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/svg/Resume.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/svg/Pause.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/online-white.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/offline-white.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/online.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/offline.svg" class="shrink-button" alt="Shrink">
            <!-- <img src="{{imageBasePath}}assets/img/Notes/ColorPentagon_blue.svg" class="shrink-button" alt="Shrink"> -->
            <!-- <img src="{{imageBasePath}}assets/img/Notes/ColorPentagon_green.svg" class="shrink-button" alt="Shrink"> -->
            <!-- <img src="{{imageBasePath}}assets/img/Notes/ColorPentagon_orange.svg" class="shrink-button" alt="Shrink"> -->
            <!-- <img src="{{imageBasePath}}assets/img/Notes/ColorPentagon_red.svg" class="shrink-button" alt="Shrink"> -->
            <img src="{{imageBasePath}}assets/img/Notes/ColorCircle_blue.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Notes/ColorCircle_green.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Notes/ColorCircle_orange.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Notes/ColorCircle_red.svg" class="shrink-button" alt="Shrink">
            <!-- <img src="{{imageBasePath}}assets/img/Toolbar/Remove Circle.svg" class="shrink-button" alt="Shrink"> -->
            <!-- <img src="{{imageBasePath}}assets/img/Toolbar/Add Circle.svg" class="shrink-button" alt="Shrink"> -->
            <img src="{{imageBasePath}}assets/img/Toolbar/Undo.svg"class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Toolbar/Redo.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Toolbar/Mask Copy.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Speaker_Icon.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Rotate-Phone-Icon.gif" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/resize-black-new.svg" class="shrink-button" alt="Shrink">
            <img src="{{imageBasePath}}assets/img/Assignments.svg" class="shrink-button" alt="Shrink">
        </div>

    </div>

    <div class="imgbook-sidebar-container" [ngClass]="sidebarConfig.position==='right'?'notes-active-right':''">
        <div class="sidebar" *ngIf="sidebarConfig.isActive && sidebarConfig['current-sidebar']=='toc'" 
        [ngClass]="sidebarConfig.position==='left'?'toc-left':sidebarConfig.position==='right'?'toc-right':''">
            <div class="sidebar-header-container" [ngClass]="(userData.role !== 'student' && userData?.launchType !== 'lti') && 'assignment-sidebar'">
                <!-- Close Icon -->
                <div class="close-button-container d-flex" [ngClass]="sidebarConfig.position==='right'?'flex-row justify-content-between right':'flex-row-reverse'">
                    <button title="{{'FOC._COMMON_ACROSS_PAGES.TOC.CLOSE_TOC' | translate }}" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocCrossBtn.currentIndex" class="close-button" (click)="toggleSidebar('toc')" [attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.TOC.SCREEN_READER.CLOSE_ICON_ALT' | translate">
                        <em aria-hidden="true" qid="toc-0"
                             class="nemo-close-new nemo-font"></em>
                    </button>
                </div>
                
                <!-- Ebook Title Section -->
                <div class="align-items-center book-title d-flex justify-content-center"  title="{{bundle.title?bundle.title:bundle['bundle-code']}}">

                    <!-- web app -->
                    <img *ngIf="!isDesktopApp && bundle.cover" src="{{bundle.cover}}" (load)="resizeSidebarWhenImageIsLoaded()" (error)="bundle.cover = null" alt="">
                    <div *ngIf="!isDesktopApp && !bundle.cover" class="no-image"></div>
                    
                    <!-- desktop app -->
                    <img *ngIf="isDesktopApp && bundleCoverUrl" [src]="sanitizeUrl" (load)="resizeSidebarWhenImageIsLoaded($event)" (error)="bundle.cover = null" alt="">
                    <div *ngIf="isDesktopApp && !bundleCoverUrl" class="no-image"></div>

                    <h1 class="title m-0">{{bundle.title?bundle.title:bundle['bundle-code']}}</h1>
                </div>

                <!-- Ebook Type Dropdown Section -->
                <div class="dropdown d-flex justify-content-center ebook-list-container" [ngClass]="(userData.role !== 'student' && userData?.launchType !== 'lti') && 'pb-3'" *ngIf="(((userData.role !== 'student') || (userData.role === 'student' && userData?.launchType !== 'lti')) && ebooksArray.length > 1) || showResourceBankButton">
                    <button class="btn dropdown-toggle d-flex avoid-focus-loss-on-user-action" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocContent.currentIndex" type="button" id="eboksDropdown" [ngClass] = "{'disabled' : !isPageLoadCompleted || !isBookToggleCompleted || !isOverlayJsonLoaded}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" qid="ebook-button-1" title="{{'FOC._COMMON_ACROSS_PAGES.TOC.TOGGLE_EBOOK' | translate }}">
                        <div class="show-ellipsis">{{ebooksMap[studentBook.meta.code]}}</div>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="eboksDropdown">
                        <a class="dropdown-item" *ngIf="showResourceBankButton" (click)="openResourceBank('toc')" [attr.qid]="'ebook-list-item-'+(ebooksArray.length+1)">
                            {{'FOC._COMMON_ACROSS_PAGES.TOC.RESOURCE_BANK' | translate}}
                            <img src="{{imageBasePath}}assets/img/external-link-purple.svg" alt="Resource Bank">
                        </a>
                        <a class="dropdown-item" [ngClass]="{'selected':(studentBook.meta.code==ebook.bookCode),'disabled': (!isDDBookEnabled(ebook))}" *ngFor="let ebook of ebooksArray; let i = index;" (click)="toggleBookHandler(ebook.bookCode, true)" href="javascript:void(0)" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocContent.currentIndex" (keydown.enter)="toggleBook(ebook.bookCode)" [attr.qid]="'ebook-list-item-'+(i+1)">{{ebook.title}}</a>
                    </div>
                </div>
                <div class="d-flex justify-content-center ebook-list-container" [ngClass]="(userData.role !== 'student' && userData?.launchType !== 'lti') && 'pb-3'" *ngIf="(userData.role === 'student' && userData?.launchType === 'lti') || (ebooksArray.length == 1 && !showResourceBankButton)">
                    <div class="show-ellipsis" title="{{ebooksMap[studentBook.meta.code]}}">{{ebooksMap[studentBook.meta.code]}}</div>
                </div>
                
                <!-- Assignment Button -->
                <div *ngIf="userData.role !== 'student' && userData?.launchType !== 'lti'" class="assignment-button-container d-flex align-items-center justify-content-center">
                    <button class="assignment-button" [ngClass]="showAssignmentLoader?'disabled':''" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocContent.currentIndex" [attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.TOC.ASSIGNMENT_MODAL' | translate" qid="assignment-button-1" (click)="showAssignmentModal()" title="{{'FOC._COMMON_ACROSS_PAGES.TOC.ASSIGNMENT_MODAL' | translate }}" id="createAssignmentBtn" >
                        <img class='add-assignment-circle' src="{{imageBasePath}}assets/img/Toolbar/Plus.svg" alt="">
                        <span>{{'FOC._COMMON_ACROSS_PAGES.TOC.ASSIGNMENT_MODAL' | translate }}</span >
                    </button>
                </div>
            </div>
            <!-- Lesson List Template (after clicking on any Unit) -->
            <div class="unit-list-scrollbar">
                <ng-container *ngFor="let unit of units; let i = index;">

                    <div [id]="'unit-details-' + unit['id'].replace( '/\//gi','')" class="unit-details">
                        <h2 class="m-0">
                        <button data-toggle="collapse" (focus)="i == 0 ? this.tabbingOrderService.firsElementOrLastElement('tocContent', 'first') : (units.length - 1 == i) ? this.tabbingOrderService.firsElementOrLastElement('tocContent', 'last') : ''" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocContent.currentIndex" [attr.data-target]="'#collapse-' + unit['id'].replace( '/\//gi','')"
                           (click)="toggleUnitPanel(unit)" [attr.qid]="'toc-expand-collapse-'+(i+1)" [attr.aria-expanded]="tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen"
                            class="d-flex justify-content-between unit-tab avoid-focus-loss-on-user-action" [ngClass]="tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen?'opened-unit-tab':''">

                            <span class="unit-name" [ngClass]="tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen ? 'opened-unit':''">
                            {{unit.name}}
                            </span>

                            <span class="caret" title=" {{ tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen ? ( 'FOC._COMMON_ACROSS_PAGES.TOC.COLLAPSE' | translate ) : ( 'FOC._COMMON_ACROSS_PAGES.TOC.EXPAND' | translate ) }}" aria-hidden="true"><i class="caret fa {{tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen?'fa-angle-up':'fa-angle-down'}}" aria-hidden="true"></i>
                            </span>

                        </button>
                        </h2>
                        <div *ngIf="tocWrapper[unit['id'].replace( '/\//gi','')]?.isOpen" [id]="'collapse-' + unit['id'].replace( '/\//gi','')" class="collapse" >
                            <div class="page-details" *ngFor="let page of unit.items; let j = index;">
                                <a [ngClass]="isActivePage(page.label)?'active':''" href="javascript:void(0);" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.tocContent.currentIndex" (click)="isActivePage(page.label) || openPage(page, {publishEventType: pageEventInteractionToc})"  [attr.qid]="'toc-list-'+(j+1)" class="d-flex page avoid-focus-loss-on-user-action" title = "{{'FOC._COMMON_ACROSS_PAGES.TOC.JUMP_TO_PAGE' | translate:{page_no:page.label } }}">

                                    <!-- web app -->
                                    <img *ngIf="!isDesktopApp" class="m-1" src="{{studentBook.meta.paths['public-assets']}}/images/thumbnail/{{page.image}}" alt="">

                                    <!-- desktop app -->
                                    <img *ngIf="isDesktopApp" class="m-1" [src]="sanitize(studentBook.meta.paths['public-assets']+'/images/thumbnail/'+page.image)" alt="">

                                    <div class="d-flex flex-column page-header">
                                        <h3 class="font-weight-bold page-title">{{page.name}}</h3>
                                        <p class="page-no">{{'FOC._COMMON_ACROSS_PAGES.TOC.PAGE_LABEL' | translate}} {{page.label}}</p>
                                    </div>
                                </a>
                            </div>
                        </div>

                    </div>

                </ng-container>
            </div>

        </div>

        <!-- Notes Warpper - container of all the notes (notes panel) -->
        <div class="notes-wrapper" *ngIf="sidebarConfig.isActive && sidebarConfig['current-sidebar']=='notes'"
        [ngClass]="sidebarConfig.position==='left'?'notes-left':sidebarConfig.position==='right'?'notes-right':''">
            <div class="notes-parent-container">
                <div class="header-container">
                    <!-- notes logo -->
                    <div class="d-inline-block notes-logo" [ngClass]="{'spanishStyles' : checkSpanish()}">
                        <img src="{{imageBasePath}}assets/img/Notes/Links-Note.svg" alt="{{'FOC._COMMON_ACROSS_PAGES.NOTES.NOTES' | translate }}">
                    </div>
    
                    <!-- notes title -->
                    <div class="d-inline-block notes-title">
                        {{'FOC._COMMON_ACROSS_PAGES.NOTES.NOTES' | translate }}
                    </div>
    
                    <!-- close icon -->
                    <button title = "{{'FOC._COMMON_ACROSS_PAGES.NOTES.CLOSE_NOTES' | translate }}" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.notesClosebtn.currentIndex" (click)="toggleSidebar('notes')" class="close-icon d-inline-block pull-right" [attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.NOTES.SCREEN_READER.CLOSE_ICON_ALT' | translate">
                        <em  qid="notes-0" 
                        class="nemo-close-new nemo-font"></em>
                    </button>
                    <div class="notes-message">
                        {{'FOC._COMMON_ACROSS_PAGES.NOTES.NOTES_MESSAGE' | translate }}
                    </div>
                </div>



                <div class="notes-container">
                    <div *ngFor="let page of pages;let i = index;" class="page-container" [ngClass]="page.isOpen?'active':''">
                        <div id="{{page.label}}" class="placeholder-for-notes" *ngIf="page.notes.length">
                            <button data-toggle="collapse" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.notesContent.currentIndex" [attr.data-target]="'#collapse-' + page.label"
                            (click)="togglePagePanel(page)" [attr.qid]="'page-expand-collapse-'+(i+1)" [attr.pageId]="'page-accordion-'+i"
                                class="d-flex justify-content-between page-title page-title-button avoid-focus-loss-on-user-action">
                                <span class="page-text">Page {{page.label}}</span>
                                <span class="caret d-flex justify-content-center">
                                    <em class="caret-glyph fa {{page.isOpen?'fa-angle-up':'fa-angle-down'}}"
                                    title=" {{ page.isOpen ? ( 'FOC._COMMON_ACROSS_PAGES.NOTES.COLLAPSE' | translate ) : ( 'FOC._COMMON_ACROSS_PAGES.NOTES.EXPAND' | translate ) }}"></em>
                                </span>
                            </button>
    
    
                            <div [id]="'collapse-' + page.label" class="collapse" *ngIf="page.isOpen">
                                <div *ngFor="let note of page.notes; let j = index;" class="note {{j==0?'first-note':j==page.notes.length-1?'last-note':''}}">
                                    <app-notes
                                        [notesConfig]="note"
                                        [pageIndex]="i"
                                        [noteIndex]="j"
                                        [currentPage] = "currentPage"
                                        [pinNoteConfig]="pinNoteConfig"
                                        (pinToPageEvent) = "onPinNote($event, true)"
                                        (quickPinAndSaveNote) = "onQuickPinAndSaveNote($event)"
                                        (addPinOnBookEvent) = "addPinOnImgBookHandler($event)"
                                        (removeNotePinEvent) = "onRemoveNotePinHandler($event)"
                                        (moveNotePinEvent) = "onMoveNotePin($event)"
                                        (exitCaptureModeEvent) = "exitCaptureMode($event)"
                                        (jumpToPageEventFromNotes) = "jumpToPageEventFromNotes($event)"
                                        (deleteNoteEvent)= "deleteNoteEvent($event, i, j)"
                                        (updateActiveNotesFlag)= "updateActiveNotesFlag($event)"
                                        (saveNoteEvent)= "saveNoteEvent($event)"
                                        (updateNoteEvent)="updateNoteEventHandler($event)"
                                        (hideAllNotesTipModals)="hideAllNotesTipModals($event)"
                                        (publishHyperlinkLaunchEvent)="publishHyperlinkLaunchEvent($event)"
                                        (backToNotesPanel)= "backToNotesPanel($event)">
                                    </app-notes>
                                </div>
                            </div>
    
                        </div>
                    </div>
    
                    <div *ngIf="isNotesBusy" class="imgbook-loader d-flex flex-column justify-content-center align-items-center">
                        <div class="loader" id="notes-loader"></div>
                        <div>{{'FOC._COMMON_ACROSS_PAGES.NOTES.LOAD_NOTES' | translate }}</div>
                    </div>
    
                    <div *ngIf="isNoteLoadFailed" class="align-items-center d-flex flex-column imgbook-loader justify-content-center">
                        <div>
                            <img class="notes-failed-img" src="{{imageBasePath}}assets/img/Persistence/error.svg" alt="{{'FOC._COMMON_ACROSS_PAGES.NOTES.LOAD_FAIL' | translate }}">
                        </div>
                        <div>{{'FOC._COMMON_ACROSS_PAGES.NOTES.FAILED_NOTES' | translate }}</div>
                    </div>
                </div>
            </div>
            

            <div class="footer d-flex footer justify-content-center">
                <button id="addNoteBtn" [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.notesContent.currentIndex" class="btn d-flex flex-row add-note-button {{toolsService.getNoteStatus() || singleNoteConfig != undefined || isNoteLoadFailed || isNotesBusy || isImgbookBusy ?'disabled':''}}"  type="button" (click)="addNote()">
                    <div>
                        <img src="{{imageBasePath}}assets/img/Notes/AddCircle.svg" alt="{{'FOC._COMMON_ACROSS_PAGES.NOTES.ADD_NEW' | translate }}">
                    </div>
                    <div aria-hidden="true" class="add-note-text">{{'FOC._COMMON_ACROSS_PAGES.NOTES.ADD_NEW' | translate }}</div>
                </button>
            </div>


        </div>
        <div class="content-container" [ngClass]="sidebarConfig.isActive? 'sidebar-open':''">

            <div class="imgbook-container">
                <!-- IMAGEBOOK CONTAINER -->
                <div id="imgbook_wrapper" #imgbook_wrapper class="d-flex">
                    <!-- Image Reader Container  -->
                    <div id="imgbook" tabindex="-1" #imgbook class="dragscroll" [class.default]="currentPageOrientation=='FIT_TO_SCREEN'"></div>
                </div>
            </div>


            <!-- IMAGEBOOK CONTENT LOADER -->
            <div id="foc-loader" class="imgbook-loader justify-content-center align-items-center">
                <div class="loader"></div>
            </div>


            <!-- OVERLAY MODAL (for audio/video hotspot) -->
            <div class="modal" id="overlay-modal" (drop)="modalService.drop($event)" (dragover)="modalService.allowDrop($event)">
                    <div class="modal-dialog" id="modal-dialog" (dragstart)="modalService.drag($event)">
                    <div class="modal-content">
                        <!-- Modal Header -->
                        <div class="modal-header">
                            <h4 class="modal-title">Coming soon!</h4>
                            <button type="button" qid="toc-62" class="close" data-dismiss="modal">&times;</button>
                        </div>

                        <!-- Modal body -->
                        <div class="modal-body ">
                            <div>
                                <span>Type : <strong>{{overlayJson?.type}}</strong></span>
                            </div>
                            <div>
                                <span>Url : <strong>{{overlayJson[overlayJson?.type]?.path}}</strong></span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="overlay-container" id="overlay-container">
            </div>

            <!-- Timer -->
            <app-timer [inputConfig]="timerConfig" [isActive]="isTimerActive" (onClose)="toggleTimerFoc(false)" (bringTimerWidgetOnTop)="timerLatestWidgetOnTop()" (onPublishTimerEvent)="publishTimerEvent($event)"></app-timer>

            <div class="lo-hotspot-container">
                <div #loHotspotHost class="placeholder-for-loHotspots"></div>
            </div>

            <div class="not-seen-div">
                <a class="not-seen-link" id="external-link-button"></a>
            </div>
            
        	<app-toast id="toast-component"></app-toast>

        </div>
        <div [hidden]="(sidebarConfig.isActive && (sidebarConfig['current-sidebar']=='toc' || sidebarConfig['current-sidebar']=='notes'))">
            <button [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.previousPageBtn?.currentIndex" type="button" class="prev-btn p-0" [ngClass]="toolbarConfig.previousPage.disabled ? 'd-none':''" [attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.TOOLBAR.PREVIOUS_PAGE' | translate" (click)="previous()" ><img src="{{imageBasePath}}assets/img/Direction=Left.svg" alt=""></button>
            <button [attr.tabIndex] = "this.tabbingOrderService.flattenedTabOrderMap.nextPageBtn?.currentIndex" type="button" class="next-btn p-0" [ngClass]="toolbarConfig.nextPage.disabled ? 'd-none':''" [attr.aria-label]="'FOC._COMMON_ACROSS_PAGES.TOOLBAR.NEXT_PAGE' | translate" (click)="next()" ><img src="{{imageBasePath}}assets/img/Direction=Right.svg" alt="" ></button>
        </div>
    </div>

    <!-- Tip's Modal -->
    <app-tip-modal [sidebarPosition]="sidebarConfig.position" [baseType]="'PDZ'" ></app-tip-modal>

    <div class="single-note-container-for-mobile" *ngIf = "singleNoteConfig">
        <app-notes
            [notesConfig]="singleNoteConfig"
            [currentPage] = "currentPage"
            [pinNoteConfig]="pinNoteConfig"
            (pinToPageEvent) = "onPinNote($event, true)"
            (quickPinAndSaveNote) = "onQuickPinAndSaveNote($event)"
            (addPinOnBookEvent) = "addPinOnImgBookHandler($event)"
            (exitCaptureModeEvent) = "exitCaptureMode($event)"
            (removeNotePinEvent) = "onRemoveNotePinHandler($event)"
            (moveNotePinEvent) = "onMoveNotePin($event)"
            (jumpToPageEventFromNotes) = "jumpToPageEventFromNotes($event)"
            (deleteNoteEvent)= "deleteNoteEvent($event)"
            (updateActiveNotesFlag)= "updateActiveNotesFlag($event)"
            (saveNoteEvent)= "saveNoteEvent($event)"
            (updateNoteEvent)="updateNoteEventHandler($event)"
            (publishHyperlinkLaunchEvent)="publishHyperlinkLaunchEvent($event)"
            (backToNotesPanel)= "backToNotesPanel($event)">
        </app-notes>
    </div>

    <!-- IMAGEBOOK CONTENT LOADER -->
    <div id="toggle-book-loader" *ngIf="!isBookToggleCompleted && !isOverlayJsonLoaded" class="imgbook-loader justify-content-center align-items-center">
        <div class="loader" [ngClass] = '{"sidebar-closed": !this.sidebarConfig.isActive}'></div>
    </div>

    <!-- TODO: Add ngIf allowing the rendering of this banner for desktop app only -->
    <offline-error-banner [isTocActive]="sidebarConfig.isActive" [tocPosition]="sidebarConfig.position"></offline-error-banner>

    <!-- Toolbar -->
    <div *ngIf="isBookDataLoaded" id="toolbar-wrapper-id" class="toolbar-wrapper">
        <app-toolbar
            [ngClass]="sidebarConfig.position ==='left'?'toc-left':sidebarConfig.position==='right'?'toc-right':''"
            [inputConfig]="toolbarConfig"
            [toolButtonOfflineState] = toolButtonOfflineState
            [ebookData] = "ebooksArray"
            [currentBook] = "ebooksMap[studentBook.meta.code]"
            [showNotesTooltip] = "showNotesTooltip"
            (navigateToUserDashboard) = "navigateToUserDashboard()"
            (switch) = "switch()"
            (enterPageNumber) = "enterPageNumber($event)"
            (jumpToPagePanelEventHandler) = "jumpToPagePanelEventHandler($event)"
            (lastVisitedPage) = "lastVisitedPage()"
            (toggleTools) = "toggleTools()"
            (toggleDrawingMenu) = "toggleDrawingMenu()"
            (toggleSelectionBoxMenu) = "toggleSelectionBoxMenu()"
            (fitToScreen)="changePageOrientation('FIT_TO_SCREEN', $event, imgBookHelperService.isFitToScreen())"
            (fitToWidth)= "changePageOrientation('FIT_TO_WIDTH', $event, imgBookHelperService.isFitToWidth())"
            (toggleTimer)="toggleTimerFoc()"
            (zoomPage)="zoomPageHandler($event)"
            (toggleBook)="toggleBookHandler($event)"
            (openResourceBank)="openResourceBank('toolbar')"
            (setCurrentTool)="setCurrentTool($event)"
            (selectionDelete)="toggleSelectionDelete(true)"
            (toggleMobileTools)="toggleMobileTools($event)"
            (hideAll)="hideAll()"
            (openMenu)="openMenu($event)"
            (closeMenu)="closeMenu()"
            (toggleSidebar)="toggleSidebar('toc')"
            (toggleSubMenu)="toggleSubMenu($event)"
            (nextPage)="next()"
            (previousPage)="previous()"
            (selectionSpotlight)="initSpotlight($event)"
            (selectionMask)="initMask($event)"
            (undo)="undo()"
            (redo)="redo()"
            (toggleImgbookLayout)="toggleImgbookLayout()"
            (addNote)="addNote()"
            (toggleNotesWrapperMobile)="toggleNotesWrapperMobile()"
            (toggleNotesWrapper)= "toggleSidebar('notes')">
        </app-toolbar>
    </div>
</div>
<!--Assignment Modal-->
<app-assignment-modal
    *ngIf="userData.role !== 'student' && userData?.launchType !== 'lti'"
    [assignableMaterialAvailable]="assignableMaterialAvailable" 
    [isPplus]="isCurrentBookPplus()" 
    [currentUserClasses]="currentUserClasses"
    [classId]="classId" 
    [spaceId]="spaceId" 
    [currentPageLabel]="currentPageLabel" 
    [bundleId]="bundleId"
    [bookId]="bookId"
    (closeAssignmentModal)="handleCreateAssignmentModalClose()"
    (publishAssignmentEvent) = "publishAssignmentEvent($event)">
</app-assignment-modal>